import { useEffect, useState } from 'react';

const KEY = 'findish_social';

function readUser() {
  try { return JSON.parse(localStorage.getItem(KEY)) || null; }
  catch { return null; }
}

export default function useSocialUser() {
  const [user, setUser] = useState(readUser);

  useEffect(() => {
    const onStorage = (e) => { if (e.key === KEY) setUser(readUser()); };
    const onCustom = () => setUser(readUser());
    window.addEventListener('storage', onStorage);
    window.addEventListener('findish-social-changed', onCustom);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('findish-social-changed', onCustom);
    };
  }, []);

  return user;
}

export function notifySocialUserChanged() {
  window.dispatchEvent(new Event('findish-social-changed'));
}
